import { SELECT_MARKER } from 'actions/markers';

export default (state=null, action) => {
	switch (action.type) {
		case SELECT_MARKER:
			return action.payload;
		default:
			return state;
	}
};